import styled from 'styled-components';

export const Container = styled.div`
  text-align: right;
`;
